export const MultiCheckboxFilter = ({config, onChange, value = []}) => {
    const selected = Array.isArray(value) ? value : (value ? [value] : []);

    const toggle = (val) => {
        const next = selected.includes(val)
            ? selected.filter(v => v !== val)
            : [...selected, val];
        onChange(next.length > 0 ? next : []);
    };

    return (
        <div className="space-y-1">
            {config.options.map((opt) => (
                <label key={opt.value}
                       className="flex items-center gap-3 p-1 cursor-pointer hover:bg-base-50 rounded transition-colors group">
                    <input
                        type="checkbox"
                        className="checkbox checkbox-primary checkbox-sm rounded-md border-base-300"
                        checked={selected.includes(opt.value)}
                        onChange={() => toggle(opt.value)}
                    />
                    <span
                        className={`text-sm font-medium ${selected.includes(opt.value) ? 'pt-dark-blue' : 'text-base-content/70'} transition-colors`}>
                        {opt.label}
                    </span>
                </label>
            ))}
        </div>
    );
};
